import {
  DOCUMENT,
  CurrencyPipe,
  isPlatformBrowser,
  Location
} from '@angular/common';
import { ChangeDetectorRef, EventEmitter, Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import {
  AbstractControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import cssVars from 'css-vars-ponyfill';
import { Application } from '@enums/application.enums';
import { ToasterService } from './toaster.service';
import { EXPERIENCE_TYPE } from '@enums/const-option.enum';
import moment from 'moment';
import { CollabPermission } from '@models/collabPermission';
import { environment } from '@environments/environment';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { SubCategory } from '@modules/edit-preference/interfaces/edit_pref.interface';
import { CommonEnums, Direction } from '@enums/comman.enums';
import { MESSAGE } from '@shared/components/profile/constant/profile-constant';
import { Messages } from '@enums/messages.enums';
import { CREATE_POST_TYPE } from '@core/api-url.enum';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InfoModalComponent } from '@components/info-modal/info-modal.component';
import { FAN_MINIMUM_AGE, Fields } from '@constants/constant';
import * as momenttz from 'moment-timezone';
import { base64ToImage, extractWhiteLabelConfig, isValidWhiteLabelConfig, setCSSVariables, transformSpecialCharacters } from '@utils/common.utils';
import { UsersData } from '@models/common.interface';
import { GtagService } from '@services/gtag.service';
import get from 'lodash/has';
import has from 'lodash/get';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HOME_STRING } from '@modules/dashboard/constants/home-strings.constant';
import { PERMISSION_KEYS } from '@shared/constants/permissions.contant';
import { MobileBridgeService } from '@services/mobile-bridge.service';
import { SHARED_DIALOG_CONSTS } from '@shared/components/shareddialog/shareddialog.constants';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '@shared/user-profile.reducer';
import { takeUntil } from 'rxjs/operators';
import { ROUTE_PATHS } from '@constants/routes';
import { STORE_MONETIZE_TYPE } from '@modules/shared/components/share-details-preview/constant';
import { BIO_PRODUCT_PREFIXES, BIO_URL_SEGMENTS } from '@modules/edit-preference/link-in-bio/create-creator-bio/linkin-bio.contants';
import { DarkPresetColorCodes, DefaultPresetColorCodes, LightPresetColorCodes } from '@modules/edit-preference/components/whitelabel-site/whitelabel-site-constant';
import { AVAILABLE_THEMES } from '@constants/theme-colors.constant';
import { ApiCallService } from '@services/api-call.service';
import { API_URLS } from '@core/api-url.enum';
import { PORTFOLIO_PROFILE_ROUTES } from '@modules/edit-preference/components/portfolio/portfolio.contants';
import { PORTFOLIO_TYPE_ROUTE_PATH_MAP } from '@modules/edit-preference/components/portfolio/portfolio.contants';
import { MarketingPageStateService } from '@modules/shared/services/marketing-page-state.service';
import { termsAndConditionsSubMerchandise, termsAndConditionsSubExperience, CREATE_PLAN_CONSTANTS } from '@modules/monetize/components/create-plan/create-plan.constant';
import cloneeDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

export interface WhiteLabelCoverPagePreviewState {
  isCoverPagePreview: boolean;
  params: Record<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  dataByEvent: EventEmitter<any> = new EventEmitter<any>();
  decodedKey: string;
  userId: string = '';
  window: Window | null;
  taggedUsers = new BehaviorSubject<CollabPermission[]>([]);
  taggedUsers$ = this.taggedUsers.asObservable();
  removedUser = new BehaviorSubject<boolean>(false);
  onReportSuccess = new Subject<{ status: boolean; type?: string; data?: any }>();
  fallowUser = new BehaviorSubject<boolean>(false);
  whiteLabelConfigUpdate = new BehaviorSubject<any>(null);
  private whiteLabelConfigData = new BehaviorSubject<any>(null);
  postSubscriptionData = new BehaviorSubject<any>(null);
  userBlockListUpdated = new BehaviorSubject<any>(null);
  subscriptionPaymentData = new BehaviorSubject<any>(null);
  selectedCategory = new BehaviorSubject<any>([]);
  editEmit = new BehaviorSubject<any>([]);
  noNextSubCat = new BehaviorSubject<boolean>(false);
  editMode = new BehaviorSubject<boolean>(false);
  shippingOptions = new BehaviorSubject<any>([]);
  selectedCategory$ = this.selectedCategory.asObservable();
  selectedSubCategory = new BehaviorSubject<any>([]);
  contentCreatorPreferences = new BehaviorSubject<any>([]);
  dateTime = new BehaviorSubject<string | null>('');
  moduleLoaderStatus = new BehaviorSubject(null);
  isResetSearch = new BehaviorSubject<boolean>(false);
  navigateHistory = new BehaviorSubject<string>('');
  isFocussed = new BehaviorSubject<boolean>(false);
  selectedTab = new BehaviorSubject<string>(Application.FOLLOW);
  orderHistoryTabs = new BehaviorSubject<boolean>(true);
  creatorSubTab = new BehaviorSubject<'following' | 'subscribed' | 'discover'>(
    'following'
  );
  hashtagSearch = new BehaviorSubject<string>('');
  followerCount = new BehaviorSubject<number>(Application.ZERO);
  followerCount$ = this.followerCount.asObservable();
  activeCreatorTab = new BehaviorSubject<'Creators' | 'Collaborators'>(
    'Creators'
  );
  postStatus = new BehaviorSubject<boolean>(false);
  postdata = new BehaviorSubject<any>({});
  tabName = new BehaviorSubject<string>('');
  defaultFormValue = new BehaviorSubject<any>({});
  subCategoryModalClosed = new BehaviorSubject<boolean>(false);
  logout = new Subject<boolean>();
  showSubscriptionPlan = false;
  myProfile: string = '';
  status: any;
  currentSubscriptionPlan = [] as any;
  mainCategory: string = '';
  lastLevelReached: boolean = false;
  currentSelectedPlan;
  shippingAddressReqData;
  texonomyHierarchy = [];
  public profileSetupIsContentCreator = false;
  whiteLabelOwnerEamil = new BehaviorSubject<string>('');
  getHostUrl: string | null = null; // replace this with whiteLable's domain to run on Local
  // getHostUrl = content.kiwi-internal.com
  loginDetails: any;
  isTwoFactorVerificationPending: boolean = false;
  readonly pendingOrderDetails = new Map<string, any>();
  readonly userFollowed$ = new Subject<undefined>();
  currentCategoryName: string = '';
  currentCategoryData = {};
  Fields: typeof Fields = Fields;
  eventStateData: any;
  eventTicketUnlockReturn: {
    pendingBuyAfterUnlock?: boolean;
    ticketLevelId?: string;
    creatorEventName?: string;
  } | null = null;
  isWhiteLabelWeb = !!environment.whiteLabelConfig;
  whiteLabelData = null;
  showBulkMessagesOnLoad: boolean = false;
  deviceInfo: string;
  isBrowser: boolean = false;
  private creatorWhitelabelData$ = new BehaviorSubject<any>(null);
  creatorWhitelabelData = this.creatorWhitelabelData$.asObservable();
  private readonly whiteLabelCoverPagePreviewState$ =
    new BehaviorSubject<WhiteLabelCoverPagePreviewState>({
      isCoverPagePreview: false,
      params: {}
    });
  readonly whiteLabelCoverPagePreviewState =
    this.whiteLabelCoverPagePreviewState$.asObservable();
  isWlsVerified = false;
  delegateAccessListLength$ = new Subject<boolean>();
  $clearProfileImage = new Subject<any>();
  loadWhiteLabelDataSubject = new BehaviorSubject(null);
  getCommentHandling = new Subject<any>();
  getReplyCommentHandling = new Subject<any>();
  commentLikeStatus = new Subject<any>();
  commentWithoutImage = new Subject<any>();
  commentWithImage = new Subject<any>();
  replyWithoutImage = new Subject<any>();
  replyWithImage = new Subject<any>();
  getReplyPages = new Subject<any>();
  deleteCommentHandling = new Subject<any>();
  onReportCommentSuccessHandler = new Subject<any>();
  closeWelcomeVideoModal = new Subject<any>();
  deleteWelcomeVideoCommentData = new Subject<any>();
  appleTouchStartupImageHrefs = [
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2048-2732.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2732-2048.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1668-2388.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2388-1668.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1536-2048.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2048-1536.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1640-2360.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2360-1640.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1668-2224.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2224-1668.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1620-2160.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2160-1620.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1488-2266.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2266-1488.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1320-2868.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2868-1320.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1206-2622.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2622-1206.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1290-2796.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2796-1290.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1179-2556.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2556-1179.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1170-2532.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2532-1170.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1284-2778.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2778-1284.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1125-2436.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2436-1125.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1242-2688.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2688-1242.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-828-1792.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1792-828.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1242-2208.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-2208-1242.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-750-1334.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1334-750.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-640-1136.jpg",
    "https://cdn-www.topfans.com/splash/whitelable/apple-splash-1136-640.jpg"
  ];
  adminImagesOverride = false;
  liveStreamPaymentCompleted = new Subject<any>();
  liveStreamPaymentInitiate = new Subject<any>();
  liveStreamShareModalClose$= new Subject<any>();
  pollUpdate$ = new Subject<{ postSk: string; post: any }>();
  referentUserDetails: Partial<{
    birth_date: string;
    gender: string;
    email: string;
    first_name: string;
    last_name: string;
    general_location: string;
  }> = {};
  private loggedInUser: any;
  private destroy$ = new Subject<void>();
  closeMusicPlayerModal = new Subject<any>();
  WLSAllowDMs: boolean;
  calendarLinkStatus$ = new Subject<any>();
  closeVideoPlayerModal$= new Subject<any>();
  marketingPagesRoutes: any = [];
  marketingProPagesRoutes: any = [];
  totalUnreadResourcesCountSubject = new BehaviorSubject<number>(Application.ZERO);

  constructor(
    private readonly ts: ToasterService,
    @Inject(DOCUMENT) private readonly doc: Document,
    @Inject(PLATFORM_ID) private platformId,
    private readonly cp: CurrencyPipe,
    public readonly router: Router,
    private readonly modalService: BsModalService,
    private readonly titleService: Title,
    private readonly meta: Meta,
    private route: ActivatedRoute,
    private readonly location: Location,
    private readonly deviceService: DeviceDetectorService,
    private readonly mobileBridgeService: MobileBridgeService,
    private readonly store: Store<fromUserProfile.UserProfileState>,
    private readonly injector: Injector,
    private readonly gtagService: GtagService,
    private readonly marketingPageStateService: MarketingPageStateService
  ) {
    this.getHostUrl = environment.websiteURL;
    if (this.getHostUrl?.endsWith('/')) {
      this.getHostUrl = this.getHostUrl.slice(0, -1);
    }
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.window = this.getWindow();
    } else {
      this.window = null;
    }
    this.isWhiteLabelWebsite();
    this.initializeLoggedInUser();
  }

  private initializeLoggedInUser() {
    this.store.select(fromUserProfile.getUserProfileItems)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.loggedInUser = res;
      });
  }

  getLoggedInUser() {
    return this.loggedInUser;
  }

  setMyProfile(myProfile: string) {
    this.myProfile = myProfile;
  }
  readonly isWhiteLabelWebsite = () => {
    this.whiteLabelConfigData.subscribe((res) => {
      this.isWhiteLabelWeb = !!res;
      this.whiteLabelData = res;
    });
    return this.isWhiteLabelWeb;
  };

  /**
   * Sets the white label configuration data and emits it to all subscribers
   */
  setWhiteLabelConfiguration(config: any): void {
    this.whiteLabelData = config;
    this.isWhiteLabelWeb = !!config;
    this.whiteLabelConfigData.next(config);
    this.whiteLabelConfigUpdate.next(config);
  }

  /**
   * Gets the current white label configuration data as an observable
   */
  getWhiteLabelConfiguration$() {
    return this.whiteLabelConfigData.asObservable();
  }

  /**
   * Gets the current white label configuration data synchronously
   */
  getWhiteLabelConfiguration(): any {
    if (this.whiteLabelConfigData.value) {
      return this.whiteLabelConfigData.value;
    } else {
      const currentConfig = extractWhiteLabelConfig();
      if (currentConfig && isValidWhiteLabelConfig(currentConfig)) {
        this.setWhiteLabelConfiguration(currentConfig);
        return currentConfig;
      } else {
        return null;
      }
    }
  }

  /**
   * White-label site "home": cover on `/` when published (all visitors);
   * otherwise authenticated users → owner profile `/{user_name}`.
   */
  getWhiteLabelHomePath(noNavToCoverPage: boolean = true): string {
    if (environment.is_whitelabel_cover_page_published === true && noNavToCoverPage) {
      return '/';
    }

    // Lazy resolve avoids circular import with AuthService → CommonService.
    const { AuthService } = require('../../../core/auth.service');
    const authService = this.injector.get(AuthService) as {
      isAuthenticated: () => boolean;
    };
    const username =
      this.getWhiteLabelConfiguration()?.user?.user_name ||
      this.whiteLabelData?.user?.user_name ||
      '';
    if (authService.isAuthenticated() && username) {
      return `/${username}`;
    }
    return '/';
  }

  navigateToWhiteLabelHome(
    extras?: NavigationExtras | null,
    noNavToCoverPage: boolean = true
  ): Promise<boolean> {
    const path = this.getWhiteLabelHomePath(noNavToCoverPage);
    // Router destructures extras, so a null must become undefined for its defaults to apply.
    return this.router.navigate([path], extras ?? undefined);
  }

  /** Sync snapshot of the creator's whitelabel site palette (TopFans dashboard). */
  getCurrentCreatorWhitelabelData(): Record<string, unknown> | null {
    const value = this.creatorWhitelabelData$.getValue();
    return value && typeof value === 'object' ? (value as Record<string, unknown>) : null;
  }

  patchCreatorWhitelabelData(partial: Record<string, unknown>): void {
    const current = this.getCurrentCreatorWhitelabelData() ?? {};
    const next = {
      ...current,
      ...partial
    };
    const whiteLabel = this.whiteLabelData?.data?.whiteLabel;
    if (whiteLabel && typeof whiteLabel === 'object') {
      this.whiteLabelData = {
        ...this.whiteLabelData,
        data: {
          ...this.whiteLabelData.data,
          whiteLabel: {
            ...whiteLabel,
            ...partial
          }
        }
      };
    }
    this.creatorWhitelabelData$.next(next);
  }

  getCurrentWhiteLabelCoverPagePreviewState(): WhiteLabelCoverPagePreviewState {
    return this.whiteLabelCoverPagePreviewState$.getValue();
  }

  setWhiteLabelCoverPagePreviewState(
    state: WhiteLabelCoverPagePreviewState
  ): void {
    this.whiteLabelCoverPagePreviewState$.next({
      isCoverPagePreview: state.isCoverPagePreview,
      params: { ...state.params }
    });
  }

  clearWhiteLabelCoverPagePreviewState(): void {
    this.whiteLabelCoverPagePreviewState$.next({
      isCoverPagePreview: false,
      params: {}
    });
  }
  
  /**
   * Gets specific white label configuration property
   */
  getWhiteLabelProperty(path: string): any {
    const config = this.getWhiteLabelConfiguration();
    if (!config) return null;
    
    return path.split('.').reduce((obj, key) => {
      return obj && obj[key] !== undefined ? obj[key] : null;
    }, config);
  }

  getMyProfile() {
    return this.myProfile;
  }

  patchFormValue(form) {
    this.defaultFormValue.next(form);
  }

  get currentCategory() {
    return this.currentCategoryName;
  }

  set currentCategory(category: string) {
    this.currentCategoryName = category;
  }

  get categoryData() {
    return this.currentCategoryData;
  }

  set categoryData(data: Object) {
    this.currentCategoryData = data;
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  getValueFromLocalStorage(keyName) {
    if (this.isBrowser) {
      return localStorage.getItem(keyName);
    }
  }

  getValueFromSessionStorage(keyName) {
    if (this.isBrowser) {
      return sessionStorage.getItem(keyName);
    }
  }

  updateModuleLoaderStatus(data) {
    this.moduleLoaderStatus.next(data);
  }

  setValueInocalStorage(keyName, value) {
    if (this.isBrowser) {
      return localStorage.setItem(keyName, value);
    }
  }

  changeFocussedStatus(status) {
    this.isFocussed.next(status);
  }

  navigationHistory(url) {
    this.navigateHistory.next(url);
  }

  setSearchReset(status) {
    this.isResetSearch.next(status);
  }

  setOrderConfirmed(value) {
    if (this.isBrowser) {
      this.window?.sessionStorage.setItem('orderConfirmed', value);
    }
  }

  getOrderConfirmed() {
    if (this.isBrowser) {
      return this.window?.sessionStorage.getItem('orderConfirmed');
    }
  }

  setBodyClass(isRemove?) {
    if (this.isBrowser) {
      if (isRemove) {
        this.doc.body.classList?.remove('modal-open');
      } else {
        this.doc.body.classList?.add('modal-open');
      }
    }
  }

  showInfoMessage(msg) {
    msg = msg?.replaceAll('"', '');
    if (msg) {
      this.ts.showInfo(msg);
    }
  }

  showErrorMessage(msg) {
    if (msg?.toString()?.length) {
      // msg = msg?.toString()?.replaceAll('"', '');
      this.ts.showError(msg);
    }
  }

  showSuccessMessage(msg) {
    msg = msg?.replaceAll('"', '');
    if (msg) {
      this.ts.showSuccess(msg);
    }
  }

  showWarningMessage(msg) {
    msg = msg?.replaceAll('"', '');
    if (msg) {
      this.ts.showWarning(msg);
    }
  }

  checkErrorStatus(err, key): boolean {
    if (key in err.result) {
      return true;
    } else {
      return false;
    }
  }

  getErrorText(err, key): any {
    if (err.result) {
      if (key in err.result) {
        return Array.isArray(err.result[key])
          ? err.result[key][Application.ZERO]
          : err.result[key];
      }
    } else {
      return '';
    }
    return '';
  }

  getSuccessText(res): any {
    if (res.result) {
      return res.result.message;
    }
  }

  isWhiteSpace(event, form: UntypedFormGroup) {
    form.controls['comment'].removeValidators([Validators.requiredTrue]);
    form.get('comment').updateValueAndValidity();
    if (!event.target.value.trim().length) {
      form.controls['comment'].reset();
      form.controls['comment'].setValidators([Validators.requiredTrue]);
      form.get('comment').updateValueAndValidity();
    }
  }

  restrictSpace(event) {
    const k = event.charCode;
    if (k === Application.THIRTY_TWO) {
      event.preventDefault();
    }
  }

  isEmptyOrSpaces(event) {
    const str1 = event.target.value;
    if (str1.trim()) {
      if (str1.indexOf('  ') >= Application.THREE) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  checkMatch(formGroup: UntypedFormGroup): boolean | undefined {
    const confPass = formGroup.get('confirmPassword')?.value;
    const pass = formGroup.get('password')?.value;
    if (pass !== confPass) {
      formGroup.get('confirmPassword')?.setErrors({ mismatch: true });
    } else {
      formGroup.get('confirmPassword')?.setErrors(null);
      return null;
    }
  }

  getKeywords(arr, key) {
    if (arr) {
      const keywords = arr.map((a) => a[key]?.trim()).join(', ');
      return this.toTitleCase(keywords);
    } else {
      return '';
    }
  }

  getUrlWithHttps() {
    if (this.isBrowser && this.doc.location?.href) {
      const url = this.doc.location.href.replace(/^http:/, 'https:');
      return url;
    }
    
    // Fallback for SSR or when location is not available
    const baseUrl = environment.websiteURL;
    if (baseUrl && this.router) {
      // Try to get current route and construct full URL
      try {
        const currentUrl = this.router.url;
        const fullUrl = baseUrl.replace(/\/$/, '') + currentUrl;
        // Ensure HTTPS
        return fullUrl.replace(/^http:/, 'https:');
      } catch (error) {
        // If router.url fails, fall back to just the base URL
        return baseUrl.replace(/^http:/, 'https:');
      }
    }
    
    if (baseUrl) {
      // Ensure HTTPS
      return baseUrl.replace(/^http:/, 'https:');
    }
    
    // Last resort fallback
    return 'https://topfans.com';
  }

  getPostKeywords(arr) {
    if (arr) {
      const keywords = arr.map((a) => a?.trim())?.join(', ');
      return this.toTitleCase(keywords);
    } else {
      return '';
    }
  }

  getTitleDesc(str, index) {
    return this.toTitleCase(str?.slice(0, index));
  }
  addAuthorForCreator(keywords) {
    this.meta.updateTag({ name: 'author', content: keywords });
  }

  whichEnvironment(topfanSeo: string, wlsSeo: string){
    if(environment.whiteLabelConfig){
      return topfanSeo;
    }else{
      return wlsSeo;
    }
  }

  setSeoTags(title, description, keywords, imageUrl?, userName?) {
    imageUrl = imageUrl ? imageUrl : 'https://cdn-www.topfans.com/topfans.png';
    this.titleService.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ name: 'keywords', content: keywords });
    if (userName) {
      this.meta.addTag({ name: 'author', content: userName });
    }
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:url',
      content: this.getUrlWithHttps()
    });
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });
    this.meta.updateTag({ name: 'twitter:site', content: '@topfans' });
    this.meta.updateTag({
      name: 'twitter:url',
      content: this.getUrlWithHttps()
    });
    // Set canonical URL for SEO
  }

  setSeoDefaultTags(
    title,
    description,
    imageUrl = 'https://cdn-www.topfans.com/topfans.png',
    keywords = ''
  ) {
    description = description.replace(/\n/g, ' ')?.replace(/ {2}/g, '');
    this.titleService.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ name: 'keywords', content: keywords });
    this.meta.updateTag({
      property: 'og:url',
      content: this.getUrlWithHttps()
    });
    this.meta.updateTag({
      name: 'twitter:url',
      content: this.getUrlWithHttps()
    });
    imageUrl = imageUrl ? imageUrl : 'https://cdn-www.topfans.com/topfans.png';
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    
    // Set canonical URL for SEO
  }

  addTwitterCreator(twitterHandle) {
    this.meta.updateTag({ name: 'twitter:creator', content: twitterHandle });
  }

  setTwitterTags(title, description) {
    description = description.replace(/\n/g, ' ')?.replace(/ {2}/g, '');
    this.titleService.setTitle(title);
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({
      name: 'twitter:url',
      content: this.getUrlWithHttps()
    });
    this.meta.updateTag({ name: 'twitter:site', content: 'TopFan' });
  }
  setDefaultTitleDescription() {
    this.titleService.setTitle(CommonEnums.defaultTitle);
    this.meta.updateTag({
      name: 'description',
      content: CommonEnums.defaultDescription
    });
    this.meta.updateTag({ name: 'keywords', content: CommonEnums.keywords });
    this.meta.updateTag({
      property: 'og:title',
      content: CommonEnums.defaultTitle
    });
    this.meta.updateTag({
      property: 'og:description',
      content: CommonEnums.defaultDescription
    });
    this.meta.updateTag({
      property: 'og:image',
      content: 'https://cdn-www.topfans.com/topfans.png'
    });
    this.meta.updateTag({
      property: 'og:url',
      content: this.getUrlWithHttps()
    });
    this.meta.updateTag({
      name: 'twitter:url',
      content: this.getUrlWithHttps()
    });
  }

  setReferSeoStuff(profileURL = 'https://cdn-www.topfans.com/topfans.png', userName) {
    this.setSeoTags(
      CommonEnums.defaultTitle,
      CommonEnums.defaultDescription,
      CommonEnums.keywords,
      profileURL,
      userName
    );
  }

  getCategoryKeywords(arr) {
    const keywords = arr.map((a) => a?.trim()).join(', ');
    return this.toTitleCase(keywords);
  }

  getFileName(fileName: string): string {
    return fileName
      .toLowerCase()
      .replace(/[&\/\\#, +()$~%'":*?<>{}]/g, '_')
      .split(' ')
      .join('_');
  }

  setTitle(title: string) {
    this.titleService.setTitle(title);
  }

  setCategoryTitleAndDesc(categoryArray, currentActiveName) {
    let keywords = this.getCategoryKeywords(categoryArray);
    const description = `Discover and interact directly with your favorite ${currentActiveName} creators on TopFan`;
    const title = `${keywords} Creators on TopFan`;
    //update page title...
    keywords = keywords + ', Creators, exclusive content, chat, direct message, livestream, merchandise, drops, video shoutout, fan club, VIP'
    this.titleService.setTitle(title);
    // update metatags...
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ name: 'keywords', content: keywords });
    // update og tags...
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({
      property: 'og:url',
      content: this.getUrlWithHttps()
    });

    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({
      name: 'twitter:url',
      content: this.getUrlWithHttps()
    });
    
    // Set canonical URL for SEO
  }

  getUserCategory(userData) {
    if (Array.isArray(userData) && userData.length > 0) {
      return userData[0].category_name || '';
    }
    return '';
  }
  setUserProfileMetaTags(userData, title = '') {
    this.updateAppleTouchStartupImages(this.appleTouchStartupImageHrefs);
    const taxonomyData = this.getTaxonomy(userData);
    const categoryArray = ([] as any[]).concat(...taxonomyData);
    const u = userData;
    const userName = `${u?.first_name || ''} ${u?.last_name || ''}`.trim();
    let keywords = this.getKeywords(categoryArray, 'name');
    let description = ``;
    if(environment.whiteLabelConfig){
      title = `Official Website of ${userName}`;
      keywords = `${keywords}, Official Website, Exclusive Content, News, Videos, Photos, Merchandise, Fan Club`;
      description = `${userName}: ${(u.bio || title).trimEnd()}${keywords ? ' - ' + keywords : ''}`;
    }else{
       title = `${userName} Official Profile and App`;
      keywords = `${keywords}, Official Website, App, iOS App, Android App, Exclusive Content, Merchandise, Fan Club, News, Videos, Photos`
      description = `${(u.bio || title).trimEnd()}${keywords ? ' - ' + keywords : ''}`;
    }
   
    const imageUrl =
      u.profile_image_url || './assets/images/svg/ic-profile.svg';
    this.setSeoTags(title, description, `${userName}, ${keywords}`, imageUrl, userName);
  }

  dynamicSeoPage(seoData) {
    if (seoData) {
      const title = seoData.seo_title;
      const keywords = seoData.keywords?.join(', ') || '';
      const description = seoData.display_description;
      const imageUrl = seoData.hero_img || './assets/images/svg/ic-profile.svg';
      // // set Seo tags...
      this.setSeoTags(title, description, keywords, imageUrl);
    }
  }

  /**
   * Injects marketing page critical CSS into document head.
   * Extracts all 6 API colors and sets CSS variables on body.marketing-page-class.
   */
  injectMarketingPageStyles(document: Document, page: Record<string, unknown>): void {
    const existingStyle = document.getElementById('marketing-page-theme');
    if (existingStyle) {
      existingStyle.remove();
    }

    const bgColor =
      this.getMarketingThemeColor(page.background_color) ??
      this.getMarketingThemeColor(page.secondary_background_color) ??
      '#ffffff';
    const secondaryBgColor =
      this.getMarketingThemeColor(page.secondary_background_color) ??
      bgColor;
    const bgTextColor = this.getMarketingThemeColor(page.background_text_color) ?? '#ffffff';
    const postTextColor = this.getMarketingThemeColor(page.post_text_color) ?? '#ffffff';
    const buttonTextColor = this.getMarketingThemeColor(page.button_text_color) ?? '#000000';
    const themeColor =
      this.getMarketingThemeColor(page.theme_color) ??
      this.getMarketingThemeColor(page.text_color) ??
      '#00d2a6';

    const style = document.createElement('style');
    style.id = 'marketing-page-theme';
    style.type = 'text/css';
    style.textContent = `
      body.marketing-page-class {
        --configBgColor: ${bgColor} !important;
        --configSecondaryBgColor: ${secondaryBgColor} !important;
        --configBgTextColor: ${bgTextColor} !important;
        --configPostTextColor: ${postTextColor} !important;
        --configButtonTextColor: ${buttonTextColor} !important;
        --configThemeColor: ${themeColor} !important;
        --marketingDetailBgColor: ${bgColor} !important;
        --marketingDetailThemeColor: ${themeColor} !important;
        --configBgMarketingPageColor: ${bgColor} !important;
        background-color: ${bgColor} !important;
      }
    `;

    if (document.head) {
      document.head.insertBefore(style, document.head.firstChild);
    }
  }

  /**
   * Applies marketing page body class and background color.
   * Returns whether body had theme-whiteLabel class (for later restore).
   */
  applyMarketingBodyClass(document: Document, bgColor?: string | null): boolean {
    const body = document?.body;
    if (!body) return false;
    const hadThemeWhiteLabelClass = body.classList.contains('theme-whiteLabel');
    body.classList.add('marketing-page-class');
    body.classList.remove(Application.THEME_DEFAULT);
    body.classList.remove(Application.THEME_DARK);
    body.classList.remove(Application.THEME_LIGHT);
    body.classList.remove('theme-whiteLabel');
    if (this.getMarketingThemeColor(bgColor)) {
      body.style.backgroundColor = bgColor as string;
    } else {
      body.style.removeProperty('background-color');
    }
    return hadThemeWhiteLabelClass;
  }

  private getMarketingThemeColor(color: unknown): string | null {
    return typeof color === 'string' && color.trim() ? color.trim() : null;
  }

  /**
   * Clears marketing page styles and restores body state.
   */
  clearMarketingPageStyles(document: Document, hadThemeWhiteLabelClass: boolean): void {
    const marketingThemeStyle = document.getElementById('marketing-page-theme');
    if (marketingThemeStyle) {
      marketingThemeStyle.remove();
    }
    if (document?.body) {
      const body = document.body;
      body.classList.remove('marketing-page-class');
      body.style.removeProperty('background-color');
      if (hadThemeWhiteLabelClass) {
        this.applyWhiteLabelBodyThemeClass();
      }
    }
  }

  /**
   * Sets body to white-label theme only: removes standard theme-* classes so they never stack
   * with theme-whiteLabel (e.g. theme-dark left from default app shell).
   */
  applyWhiteLabelBodyThemeClass(): void {
    if (!this.doc?.body) {
      return;
    }
    const body = this.doc.body;
    body.classList.remove(
      Application.THEME_DEFAULT,
      Application.THEME_LIGHT,
      Application.THEME_DARK
    );
    body.classList.add('theme-whiteLabel');
  }

  setUserPostMetaTags(up, userName) {
    const desc = `${up.description}`;
    const title = `${up.cta_title || up.description || up?.item_details?.title} - Official ${up.type} about ${userName}`;
    let description =
      desc?.length > 300
        ? desc?.slice(0, Application.TWO_HUNDRED) + '...'
        : desc?.slice(0, Application.TWO_HUNDRED);
    let keywords = this.getPostKeywords(up.user_tag);
    description = `${description} - Official news ${up.type} about ${userName} ${keywords ? ' - ' + keywords : ''}`;
    let imageUrl;
    if ((!up?.type &&  !up?.item_details?.type) || up.type === 'text' || up.type === 'link') {
      imageUrl = '';
    } else if (
      up.type === 'video' ||
      up.type === 'audio' ||
      up.type === 'downloadables' ||
      up.type === CREATE_POST_TYPE.article ||
      up.item_details?.type === SHARED_DIALOG_CONSTS.STORE
    ) {
      imageUrl = up.feed_preview_image_url || up?.item_details?.preview_image;
      keywords = keywords + ', ' + 'exclusive, exclusive content, watch';
    } else {
      imageUrl = up?.media_url?.length
        ? up?.media_url[0]
        : up?.thumbnail_url?.[0] || './assets/images/svg/ic-profile.svg';
    }
    // set post details Seo tags...
    this.setSeoTags(`${title}`, `${description}`, `${userName}, ${keywords}, News, ${up.type}, ${up.type?.toUpperCase()}, Information, Official`, imageUrl, userName);
  }

  showScreenshotProhibitedModal() {
    this.modalService.show(InfoModalComponent, {
      initialState: {
        icon: './assets/images/svg/NoScreenshot.svg',
        heading: this.isWhiteLabelWeb
          ? Fields.ScreenshotPreventionHeadingWhiteLabel
          : Fields.ScreenshotPreventionHeading,
        description: Fields.ScreenshotPreventionDescription,
        iconStyleClass: 'no-photo-img',
        showCrossBtn: false,
        buttonField: {
          type: 'button',
          class: 'btn btn-primary',
          label: Fields.ScreenshotButtonLabel
        }
      },
      class: 'modal-lg',
      backdrop: 'static'
    });
  }

  // function to get random 4 digit number...
  getUuid(length = 4) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  getWindow(): Window | null {
    if (this.isBrowser) {
      return this.doc.defaultView;
    }
  }

  scrollToTop() {
    if (this.isBrowser) {
      window.setTimeout(() => {
        const win = this.getWindow();
        if (win) {
          win.scrollTo(Application.ZERO, Application.ZERO);
        }
      }, Application.ONE_HUNDRED);
    }
  }

  isExpired(exp_month: number, exp_year: number): boolean {
    const currentDate = moment();
    const expirationDate = moment({ year: exp_year, month: exp_month - 1 });
    return currentDate.isAfter(expirationDate, 'month');
  }

  currentDate(seletedDate?: string) {
    const setDate = seletedDate ? new Date(seletedDate) : new Date();
    const setDay =
      setDate.getDate().toString().length === Application.ONE
        ? `0${setDate.getDate()}`
        : setDate.getDate();
    const setMonth =
      (setDate.getMonth() + Application.ONE).toString().length ===
      Application.ONE
        ? `0${setDate.getMonth() + Application.ONE}`
        : setDate.getMonth() + Application.ONE;
    const setHours =
      setDate.getHours().toString().length === Application.ONE
        ? `0${setDate.getHours()}`
        : setDate.getHours();
    const setMinute =
      setDate.getMinutes().toString().length === Application.ONE
        ? `0${setDate.getMinutes()}`
        : setDate.getMinutes();
    const setSecond =
      setDate.getSeconds().toString().length === Application.ONE
        ? `0${setDate.getSeconds()}`
        : setDate.getSeconds();
    return {
      date: setDate,
      second: setSecond,
      minute: setMinute,
      hours: setHours,
      day: setDay,
      dayName: setDate.toLocaleDateString('locale', { weekday: 'long' }),
      monthName: setDate.toLocaleString('default', { month: 'long' }),
      month: setMonth,
      year: setDate.getFullYear()
    };
  }

  redirectToTopfans(user_name, fromSameRoute = false) {
    if (!user_name) return;
    const currentConfig = this.getWhiteLabelConfiguration();
    if (currentConfig) {
      if (this.isBrowser) {
        return this.window?.open(`${environment.websiteURL}${user_name}`, '_blank');
      }
    } else {
      if (fromSameRoute) {
        return this.router.navigate(['', user_name], {
          relativeTo: this.route
        });
      } else {
        return this.router.navigate(['', user_name]);
      }
    }
  }

  redirectToTopFansV2(user, fromSameRoute = false) {
    if (!user) {
      return;
    }
    const isLoggedInUserCreator = get(this.getLoggedInUser(), 'is_creator', false);

    let urlPath = '';
    if (user.is_creator) {
      urlPath = user.user_name;
    } else {
      urlPath = user.refer_id;
    }
    if (!urlPath) {
      return;
    }
    const currentConfig = this.getWhiteLabelConfiguration();
    if (currentConfig) {
      if (this.isBrowser) {
        if (isLoggedInUserCreator && this.getLoggedInUser()?.gsi4pk === currentConfig?.user?.gsi4pk) {
          return this.router.navigate([ROUTE_PATHS.INSIGHTS_DETAIL_VIEW, user?.gsi4pk]);
        } else {
          if (fromSameRoute) {
            return this.router.navigate([`/${urlPath}`]);
          }
          return this.window?.open(`${this.getHostUrl}/${urlPath}`);
        }
      }
    } else {
      if (isLoggedInUserCreator && user?.gsi4pk != this.getLoggedInUser()?.gsi4pk) {
        return this.router.navigate([ROUTE_PATHS.INSIGHTS_DETAIL_VIEW, user?.gsi4pk]);
      } else {
      if (fromSameRoute) {
        return this.router.navigate(['', urlPath], {
          relativeTo: this.route
        });
      } else {
          return this.router.navigate(['', urlPath]);
        }
      }
    }
  }
  getProfileUrl(user, isRouterLink = false) {
    if (!user) {
      return null;
    }
    let urlPath = '';
    if (user.is_creator) {
      urlPath = user.user_name;
    } else {
      urlPath = user.refer_id;
    }
    if (!urlPath) {
      return null;
    }
    if (isRouterLink) {
      return ['', urlPath];
    }
    return urlPath;
  }

  encodeToUTF(key) {
    const str = encodeURIComponent(key);
    this.decodedKey = str;
    return str;
  }

  get encodedUTF() {
    return this.decodedKey;
  }

  decodeToUTF(key) {
    return decodeURIComponent(key);
  }

  encodePortfolioSk(sk: string): string {
    if (!sk) return '';
    return sk.replace(/#/g, '-');
  }

  decodePortfolioSk(encoded: string): string {
    if (!encoded) return '';
    return encoded.replace(/-/g, '#');
  }
  isValidFile(file, showToast=true): Boolean {
    const MIME_TYPE_MAP = {
      'image/png': Application.PNG,
      'image/jpeg': Application.JPEG,
      'image/jpg': Application.JPG,
      'image/gif': Application.GIF,
      'image/heif': Application.HEIC,
      'image/heic': Application.HEIC,
      'image/webp': Application.WEBP,
      'image/avif': Application.AVIF
    };
    const isValid = file.type
      ? MIME_TYPE_MAP[file.type]
      : MIME_TYPE_MAP[this.getFileExt(file)];

    if (!isValid && showToast) {
      this.showErrorMessage(Messages.INVALID_FILE);
    }
    return isValid;
  }

  getFileExt(file) {
    return `image/${file.name?.toLowerCase()?.split('.').pop()}`;
  }

  isValidAudioVideo(file, type): boolean {
    let MIME_TYPE_MAP = {};
    if (type === 'video') {
      if (file.type === 'video/quicktime') {
        MIME_TYPE_MAP = {
          'video/quicktime': 'quicktime'
        };
      } else {
        MIME_TYPE_MAP = {
          'video/mp4': Application.MP4,
          'video/x-matroska': 'mkv'
        };
      }
    } else {
      MIME_TYPE_MAP = {
        'audio/mp3': Application.MP3,
        'audio/mpeg': Application.MP3,
        'audio/wav': Application.WAV
      };
    }
    const isValid = MIME_TYPE_MAP[file.type];
    if (isValid) {
      return true;
    } else {
      // Fallback: Check file extension if MIME type is not recognized
      // This handles cases where browsers don't set MIME type correctly (e.g., MKV files)
      if (type === Fields.VIDEO_SM && file.name) {
        const fileExtension = file.name.toLowerCase().split('.').pop();
        if (fileExtension === Fields.MKV) {
          return true;
        }
      }
      return false;
    }
  }

  isValidOtherFile(value): Boolean {
    const MIME_TYPE_MAP = [
      Application.PDF,
      Application.DOC,
      Application.DOCS,
      Application.CSV,
      Application.PPTX,
      Application.EXCEL,
      Application.TXT
    ];
    const isValid = MIME_TYPE_MAP.find((item) => item === value);
    if (isValid) {
      return true;
    } else {
      return false;
    }
  }

  setTaggedUsers(users: CollabPermission[]) {
    this.taggedUsers.next([]);
    this.taggedUsers.next(users);
    return this.taggedUsers;
  }

  getTaggedUsers() {
    return this.taggedUsers.value;
  }

  setDateTime(date, isEdit?) {
    if (date && !isEdit && date !== 'object') {
      const newDate = moment.utc(date).format();
      this.dateTime.next(newDate);
    } else if (date && date !== 'object') {
      this.dateTime.next(date);
    } else {
      this.dateTime.next(null);
    }
  }

  getDateTime() {
    return this.dateTime.value;
  }

  setWhiteLabelDefaultTheme(): void {
    cssVars({
      variables: {
        '--configBgColor': Application.DEFAULT_BG_COLOR as string,
        '--configThemeColor': Application.DEFAULT_THEME_COLOR as string
      }
    });
  }

  restrictChar(event, allowDot = false): boolean | undefined {
    let k = event.charCode;
    if (event.key === Application.BACKSPACE) {
      k = Application.EIGHT;
    }
    if (
      (k >= Application.FOURTY_EIGHT && k <= Application.FIFTY_SEVEN) ||
      k === Application.EIGHT ||
      k === Application.THIRTEEN ||
      k === Application.ZERO ||
      (allowDot && k === Application.FOURTY_SIX)
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  }

  updateFeatureListData(arr): void {
    arr.forEach((ele) => {
      ele.cardType = this.getCardType(ele);
      if (ele.monatize_type === Application.EXPERIENCE) {
        ele.showTitle = '';
        const obj = EXPERIENCE_TYPE.find((item) => item.value === ele.type);
        if (obj) {
          ele.showTitle = obj.name;
        }
      }
      if (ele.monatize_type === Application.COURSE) {
        ele.priceText = this.cp.transform(
          ele.define_price_for_course.single_purchase_price,
          'USD',
          'symbol',
          '1.2-2'
        );
        if (
          ele.define_price_for_course.subscriptions &&
          ele.define_price_for_course.subscriptions.some(
            (item) => item.is_seleted
          )
        ) {
          ele.priceText = 'View Details';
        }
      }
      if (ele.monatize_type === Application.MERCHANDISE) {
        ele.priceText = '';
        if (ele.variants && ele.variants.length) {
          ele.priceText = this.cp.transform(
            ele.variants[Application.ZERO].price,
            ele.variants[Application.ZERO].currency_code || 'USD',
            'symbol',
            '1.2-2'
          );
        }
      }
      ele.totalInventory = ele.variants?.reduce(
        (acc, obj) => acc + obj.inventory_quantity,
        0
      );
      return ele;
    });
  }

  getCardType(obj): string {
    let type = '';
    switch (obj.monatize_type) {
      case Application.EXPERIENCE:
        type = `${Application.EXPERIENCE.charAt(
          Application.ZERO
        ).toUpperCase()}${Application.EXPERIENCE.slice(
          Number(Application.ONE)
        )}`;
        break;
      case Application.COURSE:
        type = `${Application.COURSE.charAt(
          Application.ZERO
        ).toUpperCase()}${Application.COURSE.slice(Number(Application.ONE))}`;
        break;
    }
    return type;
  }

  numberWithCommas(x: any) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getVarientLabel(res): string {
    const vArr = res.data.product.variant.title.split(' / ');
    let label = '';
    if (vArr.length) {
      vArr.forEach((ele) => {
        const arr = res.data.product.options.filter((item) =>
          item.values.includes(ele)
        );
        if (arr.length) {
          label = label
            ? `${label} | ${arr[Application.ZERO].name}: ${ele}`
            : `${arr[Application.ZERO].name}: ${ele}`;
        }
      });
    }
    return label.includes('Default Title') ? '' : label;
  }

  spaceValidator(control: AbstractControl): ValidationErrors | null {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
      return { required: true };
    } else {
      return null;
    }
  }

  setEditMode(flag: boolean) {
    this.editMode.next(flag);
  }

  setEditedSubCat(subCat) {
    this.editEmit.next(subCat);
  }

  setSelectedCategories(category, isRemoved?) {
    if (isRemoved) {
      this.selectedCategory.next(category);
    } else {
      this.selectedCategory.value.push(category);
      this.selectedCategory.next(this.selectedCategory.value);
    }
  }

  isLastLevelReached(): boolean {
    return this.lastLevelReached;
  }

  setLastLevelReached(flag: boolean) {
    this.lastLevelReached = flag;
  }

  getMainCategory(): string {
    return this.mainCategory;
  }

  setMainCategory(mainCategory: string) {
    this.mainCategory = mainCategory;
  }

  getSelectedCategory() {
    return this.selectedCategory$;
  }

  getSelectedCategoryValue() {
    return this.selectedCategory.value;
  }

  setSubCategories(category, isRemoved?) {
    if (isRemoved) {
      this.selectedSubCategory.next([]);
      if (category?.length) {
        category = [
          ...new Map(category.map((item) => [item['sk'], item])).values()
        ];
        this.selectedSubCategory.next(category);
      }
    } else {
      let arr = [...category];
      this.selectedSubCategory.next(arr);
    }
  }

  getSubCategoryValue() {
    return this.selectedSubCategory.value;
  }

  setContentCreatorPreferences(preferences: any[]) {
    this.contentCreatorPreferences.next(preferences);
  }

  getContentCreatorPreferencesValue() {
    return this.contentCreatorPreferences.value;
  }

  getPostSubscriptionData(res) {
    const rawLp = res.data?.loyalty_points;
    const lpNum = Number(rawLp);
    const loyalty_points =
      rawLp != null &&
      rawLp !== '' &&
      Number.isFinite(lpNum) &&
      lpNum > 0
        ? lpNum
        : null;
    return {
      collaborators: res.data?.revenue_split || [],
      indivisualPrice: res.data?.individual_price || '',
      is_indivudiual_price: res.data?.is_individual_price || false,
      is_nft_added: res.data?.is_nft || false,
      is_subscription: res.data?.is_subscription || false,
      nftIDList: res.data?.NFT || [],
      subscriptions: res.data?.subscription || [],
      international_prices: res.data?.international_prices,
      loyalty_points
    };
  }

  makeYMD(d) {
    const month = Number(d.getMonth()) + Number(Application.ONE);
    return new Date(`${d.getFullYear()}/${month}/${d.getDate()}`);
  }

  getLabelFromData(arr, labelName: string): string {
    const filteredArray = arr.filter((ele) => {
      return ele.types.includes(labelName);
    });
    if (filteredArray.length) {
      return filteredArray[Application.ZERO].long_name;
    } else {
      return '';
    }
  }

  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }
    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  getDescription(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.description) {
      data.push(parent.snapshot.data.description);
    }
    if (state && parent) {
      data.push(...this.getDescription(state, state.firstChild(parent)));
    }
    return data;
  }

  /**
   * Send a tracking event to GTM/GA4. Use for any user action (clicks, form submit, etc.).
   * @param type - Event name (e.g. 'page_view', 'total-comments', 'followers')
   * @param event - Page path or event label (e.g. current path, 'comments', 'followers')
   * @param extraParams - Optional key-value params to pass (e.g. { event_category: 'engagement', value: 1 })
   */
  setGTag(type: string, event: string, extraParams?: Record<string, unknown>) {
    if (!this.isBrowser) {
      return;
    }
    this.gtagService.sendEvent(type, {
      page_path: event,
      ...extraParams
    });
  }

  openUrl(urlToOpen) {
    if (this.isBrowser) {
      let url = '';
      if (!/^http[s]?:\/\//.test(urlToOpen)) {
        url += 'http://';
      }

      url += urlToOpen;
      window.open(url, '_blank');
    }
  }

  priceValidator(control: AbstractControl) {
    return control.value > Application.TEN_THOUSAND ||
      control.value <= Application.ZERO
      ? { inValidPrice: true }
      : null;
  }

  discountValidator(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value > min) {
        return { invalidDiscount: true };
      } else {
        return null;
      }
    };
  }

  noZeroValidator(control: AbstractControl) {
    return control.value < Application.ONE ? { lessThanZero: true } : null;
  }

  kFormatter(num) {
    const number =
      Math.abs(num) > Number(Application.NINE_HUNDRED_NINTY_NINE)
        ? `${
            Math.sign(num) *
            (Math.round(Math.abs(num) / Application.ONE_HUNDRED) /
              Application.TEN)
          }k`
        : Math.sign(num) * Math.abs(num);
    return number.toString();
  }

  // to get the country flags

  getFlag(code) {
    return `http://purecatamphetamine.github.io/country-flag-icons/3x2/${code.toUpperCase()}.svg`;
  }

  setTab(tab) {
    this.selectedTab.next(tab);
  }

  setCreatorTab(tab) {
    this.activeCreatorTab.next(tab);
  }

  setTabOnOrderHis(flag) {
    this.orderHistoryTabs.next(flag);
  }

  checkLength(e, input, numlength, maxNum) {
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft'];
    if (functionalKeys.indexOf(e.key) !== Application.MINUS_ONE) {
      return;
    }
    const keyValue = +e.key;
    if (isNaN(keyValue)) {
      e.preventDefault();
      return;
    }
    const hasSelection =
      input.selectionStart !== input.selectionEnd &&
      input.selectionStart !== null;
    let newValue;
    if (hasSelection) {
      newValue = this.replaceSelection(input, e.key);
    } else {
      newValue = input.value + keyValue.toString();
    }

    if (+newValue > maxNum || newValue.length > numlength) {
      e.preventDefault();
    }
  }

  replaceSelection(input, key) {
    const inputValue = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd || input.selectionStart;
    return (
      inputValue.substring(Application.ZERO, start) +
      key +
      inputValue.substring(end + Application.ONE)
    );
  }

  getTimeZoneAbbreviation() {
    const { 1: tz } = new Date().toString().match(/\((.+)\)/);
    if (tz.includes(' ')) {
      return tz
        .split(' ')
        .map(([first]) => first)
        .join('');
    } else {
      return tz;
    }
  }

  setCreatorSubTab(flag: 'discover' | 'following' | 'subscribed') {
    this.creatorSubTab.next(flag);
  }

  async getBlobFromURL(mediaUrl: string): Promise<Blob> {
    let blob = await this.fetchImageAsBlob(mediaUrl);
    if (blob) {
      return blob;
    }
  }

  async fetchImageAsBlob(url: string) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(Messages.SOMETHING_WENT_WRONG);
      }
      const blob = await response.blob();
      return blob;
    } catch (error) {
      this.showErrorMessage(error);
    }
  }

  async blobToFile(blob: Blob, fileName: string): Promise<File> {
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now()
    });
    return file;
  }

  formatBytes(bytes, decimals) {
    if (!+bytes) return '0 Bytes';
    const k = Application.ONE_THOUSAND_TWENTY_FOUR;
    let dm = decimals < Application.ZERO ? Application.ZERO : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(Number(dm)))} ${
      sizes[i]
    }`;
  }

  setScrolledPost(data) {
    this.postdata.next(data);
  }

  setScrolledPostStatus(status) {
    this.postStatus.next(status);
  }
  setTabName(istabName) {
    this.tabName.next(istabName);
  }

  getNFT(nft) {
    return nft.substring(nft.length - Application.FIVE).toUpperCase();
  }

  shareDataByEvent = (data?: any) => {
    this.dataByEvent.emit(data);
  };

  createTaxonomyObject(
    pk: string,
    sk: string,
    name: string,
    categoryId: string,
    showProfile_chevron: boolean,
    mainCategory: string
  ) {
    mainCategory = mainCategory ?? name;
    return { pk, sk, name, categoryId, showProfile_chevron, mainCategory };
  }

  processSubCategories(subCategories: SubCategory[]) {
    return subCategories.flatMap((subCat) => {
      if (subCat?.tempCategory_name) {
        const newNames = subCat.tempCategory_name.split(' , ');
        return newNames.map((name, index) => {
          const pk = subCat?.[`${name}PK`] || subCat.pk;
          const sk = subCat?.[`${name}SK`] || subCat.sk;
          const categoryId =
            subCat?.[`${name}category_id`] || subCat.category_id;
          const showProfile_chevron = index < 1 ? true : false;
          const mainCategory = subCat?.mainCategory;
          return this.createTaxonomyObject(
            pk,
            sk,
            name,
            categoryId,
            showProfile_chevron,
            mainCategory
          );
        });
      }
      return this.createTaxonomyObject(
        subCat.pk,
        subCat.sk,
        subCat.category_name,
        subCat.category_id,
        true,
        subCat?.mainCategory
      );
    });
  }

  getTaxonomy(user: UsersData) {
    if (!user?.user_category) {
      user.category.forEach((category: any) => {
        category.options =
          has(category, 'options') && category.options?.length > 0
            ? category.options
            : [[]];
        user.sub_category?.forEach((subCategory: any) => {
          if (category.sk === subCategory.category_id) {
            category.options[0].push(subCategory);
          }
        });
      });
      user.user_category = user.category;
    }
    return user.user_category?.flatMap((category) => {
      return (
        category.options?.map((catBoxes) => {
          const categoryName =
            category.tempCategory_name || category.category_name;
          const catObj = [
            this.createTaxonomyObject(
              category.pk,
              category.sk,
              categoryName,
              category.sk,
              true,
              category?.mainCategory
            )
          ];
          const subCategoryObjects = this.processSubCategories(
            catBoxes as SubCategory[]
          );
          return [...catObj, ...subCategoryObjects];
        }) || []
      );
    });
  }

  // convert taxonomy data according to ui
  mapTaxonomy(data, item) {
    let finalData = [];
    if (item?.category_name) {
      finalData.push({
        pk: item?.pk,
        sk: item?.sk,
        name: item?.category_name,
        category_id: item?.category_id,
        showProfile_chevron: true
      });
    }
    let filterData = data?.sub_category
      ?.filter((el) => {
        if (el && el[Application.CATEGORY_ID]) {
          return item[Application.SK] === el[Application.CATEGORY_ID];
        }
      })
      .sort((a, b) => a.level_count - b.level_count);
    if (!filterData || filterData.length === 0) {
      return finalData || ''; // If filterData is empty, return just the category_name
    }
    filterData?.forEach((element, i) => {
      const profile_chevron =
        element?.level_count === filterData[i - 1]?.level_count ? false : true;
      finalData.push({
        pk: element?.pk,
        sk: element?.sk,
        name: element?.category_name,
        category_id: element?.category_id,
        showProfile_chevron: profile_chevron
      });
    });
    return finalData;
  }

  updateProfileTheme(selectedTheme: string): void {
    if (this.isWhiteLabelWeb) {
      return;
    }
    this.updateTheme(selectedTheme);
  }

  updateTheme(selectedTheme: string) {
    if (!this.isBrowser) {
      return;
    }
    if (this.isWhiteLabelWeb) {
      return;
    }
    if (this.marketingPageStateService.isMarketingPageVisible) {
      return;
    }
    if (selectedTheme === Application.THEME_DEFAULT) {
      setCSSVariables(DefaultPresetColorCodes, AVAILABLE_THEMES.default);
    } else if (selectedTheme === Application.THEME_LIGHT) {
      setCSSVariables(LightPresetColorCodes, AVAILABLE_THEMES.light);
    } else if (selectedTheme === Application.THEME_DARK) {
      setCSSVariables(DarkPresetColorCodes, AVAILABLE_THEMES.dark);
    }
    
    if (!this.isBrowser) {
      return;
    }
    const theme = selectedTheme || Application.THEME_DARK;
    const themeClasses = [Application.THEME_DEFAULT, Application.THEME_LIGHT, Application.THEME_DARK] as string[];
    const selectedThemeExists = this.doc.body.classList.contains(theme);
    const hasAnyTheme = themeClasses.some(themeClass => this.doc.body.classList.contains(themeClass));
    
    if (selectedThemeExists) {
      themeClasses
        .filter(themeClass => themeClass !== theme)
        .forEach(themeClass => this.doc.body.classList.remove(themeClass));
    } else if (!hasAnyTheme) {
      this.doc.body.classList.add(theme);
    } else {
      themeClasses.forEach(themeClass => this.doc.body.classList.remove(themeClass));
      this.doc.body.classList.add(theme);
    }

    this.doc.body.classList.remove('theme-whiteLabel');
    
    this.mobileBridgeService.sendThemeCodes(theme);
  }

  navigateToTexonomyURL(item, data, index, isLoggedIn) {
    if (this.isBrowser) {
      const queryURL = data
        .slice(0, index + 1)
        .map((category, idx) => {
          return idx <= index ? category.name : '';
        })
        .join('/');
      let url = '';
      const urlTexoArr = data.slice(0, index + 1);
      this.texonomyHierarchy = [];
      this.getTexonomyHierarchy(urlTexoArr, item);
      this.texonomyHierarchy.push(item);
      const categories = this.texonomyHierarchy
        .map((d) => d.name.trim())
        ?.join('/');
      if (item.categoryId) {
        url = `home/${transformSpecialCharacters(categories, true)}`;
      } else {
        const catID = window.btoa(`${item.sk}`);
        url = `home/${categories.toLowerCase()}/${catID}`;
      }
      this.router.navigate([url], {
        queryParams: isLoggedIn
          ? { url: transformSpecialCharacters(queryURL, true) }
          : undefined
      });
    }
  }

  getTexonomyHierarchy(arr, item) {
    const upperHierarchyObj = arr.find((a) => a.sk === item.pk);
    if (upperHierarchyObj) {
      this.texonomyHierarchy.push(upperHierarchyObj);
      this.getTexonomyHierarchy(arr, upperHierarchyObj);
    } else {
      return this.texonomyHierarchy.reverse();
    }
  }

  navigateToPostDetail(
    type,
    username,
    sk,
    pk,
    navigate = true,
    index?: number,
    feedType?: string,
    originalPk: string = '',
    imgIndex?: number,
    currentTime?: number,
    isAllPostFilter: boolean = false
  ) {
    if (this.isBrowser) {
      if (sk && pk && type === '/post') {
        let key = '';
        key = sk.includes('%23') ? '%23' : '#';
        const data = sk.split(key);
        let urlPre = '';
        let downloadableUrl = '';
        if (data[0] === CREATE_POST_TYPE.downloadable.toUpperCase()) {
          downloadableUrl = `dashboard/merchandise-details/${username}&${pk}/${encodeURIComponent(originalPk)}/${sk}/store`;
        } else if (data[Application.ZERO] === PERMISSION_KEYS.WELCOME_MESSAGE) {
          urlPre = HOME_STRING.WELCOME_MESSAGE;
        } else {
          switch (data[Application.TWO]) {
            case 'TEXT':
              urlPre = 'text';
              break;
            case 'IMAGE':
              urlPre = 'image';
              break;
            case 'VIDEO':
              urlPre = 'video';
              break;
            case 'POLL':
              urlPre = 'poll';
              break;
            case 'LINK':
              urlPre = 'link';
              break;
            case 'LIVESTREAM':
              urlPre = 'livestream';
              break;
            case 'AUDIO':
              urlPre = 'audio';
              break;
            case CREATE_POST_TYPE.reel.toUpperCase():
              urlPre = CREATE_POST_TYPE.reel;
              break;
            case CREATE_POST_TYPE.giveAway.toUpperCase():
              urlPre = CREATE_POST_TYPE.giveAway;
              break;
            case CREATE_POST_TYPE.article.toUpperCase():
              urlPre = CREATE_POST_TYPE.article;
              break;
            case CREATE_POST_TYPE.fundraiser:
              urlPre = CREATE_POST_TYPE.fundraiser;
              break;
            case CREATE_POST_TYPE.downloadable.toUpperCase():
              // Simplified downloadable URL structure: /{username}&{gsi4pk}/downloadable/{id}/{type}
              const downloadableId = sk.split('#')[1]; // Extract ID from "DOWNLOADABLES#1749678524636#USER#..."
              downloadableUrl = `dashboard/merchandise-details/${username}&${pk}/downloadable/${downloadableId}/DOWNLOADABLES`;
              urlPre = CREATE_POST_TYPE.downloadable;
              break;
            default:
              return;
          }
        }
        const id = window.btoa(`${data[Application.ONE]}:${pk}`);
        if (navigate) {
          let queryParams: any = {};
          if (imgIndex) {
            queryParams.imgIndex = imgIndex;
          }
          if (feedType) {
            queryParams.type = feedType;
          }

          const url = [`${type}/${username}/${urlPre}/${id}`];
          const state = {
            ...(currentTime ? { currentTime } : {}),
            ...(!isAllPostFilter ? { postTypePlaceholder: data[Application.TWO] } : {})
          };
          this.router.navigate(url, { queryParams, state });
        } else {
          if (downloadableUrl) {
            return downloadableUrl;
          } else if (feedType) {
            return `${type}/${username}/${urlPre}/${id}?type=${feedType}`;
          } else {
            return `${type}/${username}/${urlPre}/${id}`;
          }
        }
      } else {
        const data = sk.split('#');
        const id = window.btoa(`${data[Application.TWO]}:${pk}`);
        this.router.navigate([`${type}/${username}/${id}`], {
          queryParams: { activeID: index }
        });
      }
    } else {
      if (this.isBrowser) {
        const data = sk.split('#');
        const id = window.btoa(`${data[Application.TWO]}:${pk}`);
        if (navigate) {
          this.router.navigate([`${type}/${username}/${id}`], {
            queryParams: { activeID: index }
          });
        } else {
          return `${type}/${username}/${id}?activeID=${index}`;
        }
      }
    }
  }

  getExactWalletAmount(amount) {
    return (
      Math.trunc(amount * Application.ONE_HUNDRED) / Application.ONE_HUNDRED
    );
  }

  setWhiteLabelOwnerEmail(data) {
    if (data) {
      data = data.split('#');
      this.whiteLabelOwnerEamil.next(data[Application.ONE]);
    }
  }

  fetchCreatorWhitelabelData(): void {
    const apiCallService = this.injector.get(ApiCallService);
    apiCallService.get(API_URLS.getUsersWhitelabel, false).subscribe({
      next: (res) => {
        if (res?.status && res?.data && Object.keys(res.data).length) {
          this.creatorWhitelabelData$.next(res.data.whiteLabel);
          this.isWlsVerified = !!res.data.enable;
          this.setWhiteLabelOwnerEmail(res?.data?.sk);
        } else {
          this.creatorWhitelabelData$.next(null);
          this.isWlsVerified = false;
        }
      },
      error: () => {
        this.creatorWhitelabelData$.next(null);
        this.isWlsVerified = false;
      }
    });
  }

  isReqDataEmpty = (data) => {
    return Object.values(data).every((value) => {
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      return !value;
    });
  };

  locationBack() {
    this.location.back();
  }

  getCurrentLocation(): Promise<{ latitude: number; longitude: number }> {
    return new Promise((resolve, reject) => {
      if (navigator?.geolocation) {
        navigator?.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          },
          (error) => reject(error)
        );
      } else {
        reject(new Error(`${Application.GEO_LOCATION_NOT_SUPPORTED_MSG}`));
      }
    });
  }

  checkForScrollbarExistence(sliderOuter: HTMLElement | null) {
    if (sliderOuter) {
      const hasScrollbar = sliderOuter.scrollWidth > sliderOuter.clientWidth;
      return hasScrollbar;
    }
  }

  getCurrentWidth(outsider: HTMLElement, itemTag: string) {
    const items: HTMLElement[] = Array.from(outsider.querySelectorAll(itemTag));
    const containerRect = outsider.getBoundingClientRect();

    let totalVisibleWidth = 0;
    for (const item of items) {
      const itemRect = item.getBoundingClientRect();
      if (
        itemRect.left >= containerRect.left &&
        itemRect.right <= containerRect.right
      ) {
        totalVisibleWidth += item['offsetWidth'];
      }
    }
    return totalVisibleWidth;
  }

  horizontalScroll(
    direction: Direction,
    outsider,
    itemTag,
    callback: () => void
  ) {
    if (this.isBrowser) {
      const itemWidth =
        this.getCurrentWidth(outsider, itemTag) > 0
          ? this.getCurrentWidth(outsider, itemTag)
          : 400;
      if (direction === 'right') {
        outsider.scrollBy({
          left: itemWidth,
          behavior: 'smooth'
        });
      } else {
        outsider.scrollBy({
          left: -itemWidth,
          behavior: 'smooth'
        });
      }
  
      callback();
    }
  }

  getUserId(): string {
    return this.userId;
  }

  setUserId(userId: string) {
    this.userId = userId;
  }

  showSuspendedPage(userId: string) {
    this.router.navigate([userId]);
  }

  setAccountStatus(isSuspended: boolean): {
    accountStatus: string;
    accountStatusReason: string;
  } {
    return {
      accountStatus: this.getAccountStatus(isSuspended),
      accountStatusReason: this.getStatusReason(isSuspended)
    };
  }

  getAccountStatus(isSuspended: boolean): string {
    return isSuspended ? MESSAGE.ACCOUNT_SUSPENDED : MESSAGE.ACCOUNT_PAUSED;
  }

  getStatusReason(isSuspended: boolean): string {
    return isSuspended ? MESSAGE.SUSPENSION_REASON : MESSAGE.PAUSED_REASON;
  }
  getWidth(input: HTMLInputElement, minWidth: number, maxWidth: number) {
    const textLength = input.value.length;
    return Math.min(Math.max(minWidth, textLength * 12), maxWidth);
  }

  getbase64CroppedImage(element): Promise<string> {
    return new Promise((resolve) => {
      element
        .crop({
          type: 'base64',
          scale: Application.ONE_POINT_SEVEN_FIVE,
          quality: Application.ONE
        })
        .then(function (output) {
          return resolve(output);
        });
    });
  }

  isValidImageSize(imageElement: HTMLImageElement): boolean {
    return (
      imageElement.naturalWidth >= Application.BANNER_WIDTH &&
      imageElement.naturalHeight >= Application.BANNER_HEIGHT
    );
  }

  isValidTarget(elemTarget: HTMLInputElement): boolean {
    return (
      elemTarget instanceof HTMLInputElement && elemTarget.files?.length > 0
    );
  }

  getTimeZoneAbbreviationFormat(timeZone: string): string {
    try {
      const currentTime = momenttz.tz(timeZone);
      const abbreviation = currentTime.format('z');
      return abbreviation.toUpperCase();
    } catch (error) {
      return '';
    }
  }

  formatTo12HourTime(time24) {
    if (!time24) {
      return '';
    }
    if (time24.split(' ')?.length === 2) {
      return time24;
    }
    const [hoursStr, minutesStr] = time24.split(':');
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minutesFormatted} ${ampm}`;
  }

  clearToastMsgs() {
    this.ts.clear();
  }

  clearLocalStorageValues(key: string) {
    if (this.isBrowser) {
      localStorage.removeItem(key);
    }
  }

  logoutUser() {
    this.logout.next(true);
  }

  setLoginDetails(loginDetails: any) {
    this.loginDetails = loginDetails;
  }

  getLoginDetails() {
    return this.loginDetails;
  }

  isUser18Above(birthDate: string) {
    const today = moment();
    const birthMoment = moment(birthDate, 'DD-MM-YYYY');
    const age = today.diff(birthMoment, 'years');
    return age >= 18;
  }

  openTopfansSite() {
    if (this.isBrowser) {
      window.open('https://topfans.com/', '_blank');
    }
  }
  navigateToProfile(userName: string, isCreator = false) {
    if (isCreator && userName) {
      this.openUrl(`${environment.websiteURL}/${userName}`);
    }
  }
  isLandscapeImage(awsSrc: string): Promise<boolean> {
    return new Promise((resolve) => {
      const image = new Image();

      image.onload = () => {
        const isLandscape = image.naturalWidth > image.naturalHeight;
        resolve(isLandscape);
      };

      image.onerror = () => {
        resolve(false);
      };
      image.src = awsSrc;
    });
  }
  isLandscapeImageFromFile(file: File): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const image = new Image();
        image.onload = () => {
          const isLandscape = image.naturalWidth > image.naturalHeight;
          resolve(isLandscape);
        };
        image.onerror = () => {
          reject(false);
        };
        image.src = event.target.result as string;
      };

      reader.onerror = () => {
        resolve(false);
      };

      reader.readAsDataURL(file);
    });
  }

  setdeviceInfo() {
    if (this.isBrowser) {
      const deviceInfo = this.deviceService.getDeviceInfo();
      if (deviceInfo.deviceType === Application.MOBILE) {
        this.deviceInfo = `${deviceInfo.os} - ${deviceInfo.browser}: ${deviceInfo.browser_version}`;
      } else {
        this.deviceInfo = `${deviceInfo.os} ${deviceInfo.deviceType} - ${deviceInfo.browser}: ${deviceInfo.browser_version}`;
      }
    }
  }

  getDeviceInfo() {
    if (!this.deviceInfo) {
      this.setdeviceInfo();
    }
    return this.deviceInfo;
  }

  extractVideoThumbnail(videoFile: File): Promise<File> {
    return new Promise((resolve, reject) => {
      // Check if we are on the browser platform
      if (!this.isBrowser) {
        return reject('This operation can only be performed in the browser.');
      }

      const videoElement = document.createElement('video');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // Use FileReader to load the video as a data URL

      videoElement.onloadeddata = () => {
        if (videoElement.videoWidth && videoElement.videoHeight) {
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;

          // Ensure the video is playing to capture the thumbnail at a specific time
          videoElement
            .play()
            .then(() => {
              videoElement.pause(); // Pause immediately after starting to capture frame
              context.drawImage(
                videoElement,
                0,
                0,
                canvas.width,
                canvas.height
              );

              // Convert canvas to Base64 image and then to Blob
              const thumbnailDataUrl = canvas.toDataURL('image/png');
              const thumbnailBlob = this.base64ToBlob(
                thumbnailDataUrl,
                'image/png'
              );
              const thumbnailFile = new File(
                [thumbnailBlob],
                `${videoFile.name}_thumbnail.png`,
                { type: 'image/png' }
              );

              resolve(thumbnailFile); // Return the thumbnail file
            })
            .catch((error) => {
              console.error('Error capturing thumbnail from video:', error);
              reject('Error capturing thumbnail from the video.');
            });
        } else {
          reject(
            'Video dimensions are unavailable, unable to capture thumbnail.'
          );
        }
      };

      videoElement.onerror = (event) => {
        console.error('Error loading video:', event);
        reject(`Error loading video: ${event}`);
      };
      videoElement.src = URL.createObjectURL(videoFile);
    });
  }

  base64ToBlob(base64: string, mimeType: string): Blob {
    const arr = base64.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mimeType });
  }
  onDownloadMedia(imageUrl: string): void {
    if (this.isBrowser) {
      fetch(imageUrl)
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('Error downloading the image:', error);
        });
    }
  }
  showNoPermissionError() {
    this.showErrorMessage(Application.DELEGATE_PAYMENT_RESTRICTION_MSG);
  }
  getPastDate(yearDifference = FAN_MINIMUM_AGE) {
    const currentDate = this.currentDate(); // Use existing function
    const year = currentDate.year - yearDifference;

    // Construct the max date string in "YYYY-MM-DD" format
    const maxDateString = `${year}-${currentDate.month}-${currentDate.day}`;

    return new Date(maxDateString);
  }

  isPWA() {
    if(this.isBrowser) {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        (window?.navigator as any).standalone === true
      );
    }
  }

  loadWhiteLabelData() {
    this.loadWhiteLabelDataSubject.next(true);
  };

  /**
   * Updates all <link rel="apple-touch-startup-image"> href values in the document head.
   * @param newHrefs Array of new href values (should match the order of the existing links)
   * @returns Promise<void>
   */
  async updateAppleTouchStartupImages(newHrefs: string[]): Promise<void> {
      if(this.isBrowser && environment.whiteLabelConfig){
      const links = this.doc.querySelectorAll('link[rel="apple-touch-startup-image"]');
      links.forEach((link: HTMLLinkElement, idx: number) => {
        if (newHrefs[idx]) {
          link.href = newHrefs[idx];
        }
      });
      await Promise.resolve();
    }
  }

  /**
   * Handle GIF file upload directly without cropping/compression
   * @param file - GIF file to upload
   * @param recommendedSize - Recommended size object with width and height (e.g., { width: 400, height: 400 })
   * @returns Promise with file and dimensions
   */
  async handleGifFileUpload(file: File, recommendedSize?: { width: number; height: number }): Promise<{ file: File, imageWidth: number, imageHeight: number }> {
    if (!file) throw new Error(Fields.NO_FILE_SELECTED);
    if (file.type !== Application.IMAGE_GIF_TYPE) throw new Error(Messages.INVALID_FILE_TYPE);

    const imageDimensions = await new Promise<{ width: number, height: number }>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target!.result as string;
        image.onload = () => {
          resolve({ width: image.naturalWidth, height: image.naturalHeight });
        };
        image.onerror = () => reject(new Error(Fields.FAILED_LOAD_IMAGE));
      };
      reader.onerror = () => reject(new Error(Fields.FAILED_READ_FILE));
    });

    // Validate recommended size if provided - throw error to prevent upload
    if (recommendedSize) {
      if (imageDimensions.width !== recommendedSize.width || imageDimensions.height !== recommendedSize.height) {
        throw new Error(`GIF dimension must be exactly ${recommendedSize.width}x${recommendedSize.height} pixels. Current size is ${imageDimensions.width}x${imageDimensions.height} pixels.`);
      }
    }

    return {
      file: file, // Return original file without compression
      imageWidth: imageDimensions.width,
      imageHeight: imageDimensions.height
    };
  }

  async handleFileChangeEvent(event: Event, options: {
    maxSize: number,
    minWidth: number,
    minHeight: number,
    isValidFile: (file: File) => boolean,
    uploadImageCompress: (file: File, quality?: number, cdr?: ChangeDetectorRef) => Promise<any>;
    cdr?: ChangeDetectorRef
    maxSizeMessage?: string;
    recommendedSize?: { width: number; height: number }; // Optional recommended size for GIFs
  }): Promise<{ file: File, imageWidth: number, imageHeight: number, event: Event, isGif?: boolean }> {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[Application.ZERO];
    if (!file) throw new Error(Fields.NO_FILE_SELECTED);
    if (file.size > options.maxSize) throw new Error(options.maxSizeMessage || Messages.imageFileSizeLimit);
    if (!options.isValidFile(file)) throw new Error(Fields.INVALID_FILE_TYPE);

    // Handle GIF files directly without compression
    if (file.type === 'image/gif') {
      const gifResult = await this.handleGifFileUpload(file, options.recommendedSize);
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(gifResult.file);
      input.files = dataTransfer.files;
      return {
        file: gifResult.file,
        imageWidth: gifResult.imageWidth,
        imageHeight: gifResult.imageHeight,
        event,
        isGif: true
      };
    }

    // Handle other image types with compression
    const convertedFile = await options.uploadImageCompress(file, Application.ZERO_POINT_FOUR, options.cdr);
    options?.cdr?.detectChanges();
    const imageDimensions = await new Promise<{ width: number, height: number }>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(convertedFile);
      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target!.result as string;
        image.onload = () => {
          resolve({ width: image.naturalWidth, height: image.naturalHeight });
        };
        image.onerror = () => reject(new Error(Fields.FAILED_LOAD_IMAGE));
      };
      reader.onerror = () => reject(new Error(Fields.FAILED_READ_FILE));
    });
    if (imageDimensions.width < options.minWidth || imageDimensions.height < options.minHeight) {
      throw new Error(`Width of image should be greater than ${options.minWidth} pixels and height of image should be greater than ${options.minHeight} pixels`);
    }

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(convertedFile);
    input.files = dataTransfer.files;
    return {
      file: convertedFile,
      imageWidth: imageDimensions.width,
      imageHeight: imageDimensions.height,
      event,
      isGif: false
    };
  }

  async handleImageFeedClicked(params: {
    croppedImage: string;
    imageChangedEvent: any;
    base64ToFile: (base64: string) => Blob;
    isValidFile: (file: File) => boolean;
    uploadService: any;
    apiUrl: string;
    folder: string;
    fileType: string;
    fileName?: string;
    uploadImageCompress: (file: File, quality?: number, cdr?: ChangeDetectorRef) => Promise<any>;
    cdr?: ChangeDetectorRef;
    isMobileApp?: boolean;
    mobileFileData?: { uri: string; fileName: string };
    onProgress?: (progress: number) => void;
    isGif?: boolean; // Flag to indicate if file is GIF
  }): Promise<{ preview: string; url: string }> {
    let feedBanner: File;
    if (params.isMobileApp) {
      feedBanner = base64ToImage(params.mobileFileData.uri, params.mobileFileData.fileName);
    } else {
      const uploadFile = params.imageChangedEvent.target.files[Application.ZERO];
      // For GIF files, use original file directly without cropping
      if (params.isGif && uploadFile.type === Application.IMAGE_GIF_TYPE) {
        feedBanner = uploadFile;
      } else {
        const blob = params.base64ToFile!(params.croppedImage!);
        feedBanner = new File([blob], uploadFile.name, {
          type: params.fileType || uploadFile.type,
        });
      }
    }

    if (!params.isValidFile(feedBanner)) throw new Error(Fields.INVALID_FILE_TYPE);

    // Skip compression for GIF files
    if (!params.isGif || feedBanner.type !== 'image/gif') {
      feedBanner = await params.uploadImageCompress(feedBanner, Application.ZERO_POINT_FOUR, params.cdr);
    }
    params?.cdr?.detectChanges();
    const preview = await new Promise<string>((resolve, reject) => {
      const fReader = new FileReader();
      fReader.onload = (event) => {
        resolve(event.target!.result as string);
      };
      fReader.onerror = () => {
        reject(new Error(Fields.FAILED_READ_FILE));
      };
      fReader.readAsDataURL(feedBanner);
    });

    const audioPreview =
      params.fileName ||
      `post_${Date.now()}.${feedBanner.name
        .toLowerCase()
        .replace(/[&\/\\#, +()$~%'":*?<>{}]/g, '_')
        .split(' ')
        .join('_')}`;

    const fileObject = {
      file: feedBanner,
      fileName: audioPreview,
      folder: params.folder,
    };

    return new Promise((resolve, reject) => {
      params.uploadService.uploadFileData(params.apiUrl, fileObject, !!params.onProgress, params.cdr).subscribe({
        next: (res: any) => {
          params?.cdr?.detectChanges();
          if (res.progressStatus === Application.UPLOADING && res.progress !== undefined && params.onProgress) {
            params.onProgress(res.progress);
            return;
          }
          if (res.progressStatus === Application.RESTRICTED && res.restrictedImage) {
            reject({ restricted: true, restrictedImage: res.restrictedImage, message: Fields.RESTRICTION_CONTENT_DETECTED });
            return;
          }
          if (res.progressStatus === Application.COMPLETED) {
            if (params.onProgress) {
              params.onProgress(100);
            }
            resolve({ preview, url: res.data });
          }
        },
        error: () => {
          reject(new Error(Fields.UPLOAD_FAILED));
        },
      });
    });
  }

  /**
   * Navigate to store product detail page based on product type or return URL
   * @param productValue - Product object with product_type, pk, and sk
   * @param user - User object with user_name and gsi4pk
   * @param returnUrlOnly - Optional parameter. If true, returns URL string instead of navigating
   * @returns boolean | string - Returns true if navigation was successful, false if failed, or URL string if returnUrlOnly is true
   */
  navigateToStoreProduct(productValue: any, user: any, returnUrlOnly?: boolean): boolean | string {
    if (!productValue || !user) {
      return returnUrlOnly ? '' : false;
    }

    let pk = '';
    let sk = '';
    let URL = '';

    if ([STORE_MONETIZE_TYPE.merchandise, STORE_MONETIZE_TYPE.nfts, STORE_MONETIZE_TYPE.nft].includes(productValue?.product_type)) {
      pk = productValue.pk?.replace(BIO_PRODUCT_PREFIXES.USER, '') || '';
      sk = productValue.sk?.replace(BIO_PRODUCT_PREFIXES.USER, '') || '';
      const merchSk = sk?.split(BIO_PRODUCT_PREFIXES.HASH)?.[1];
      if (productValue?.product_type === STORE_MONETIZE_TYPE.merchandise) {
        URL = `${BIO_URL_SEGMENTS.DASHBOARD_MERCHANDISE_DETAIL}/${user?.user_name}/${encodeURIComponent(merchSk)}/${BIO_URL_SEGMENTS.STORE}/${STORE_MONETIZE_TYPE.merchandise}`;
      } else {
        URL = `${BIO_URL_SEGMENTS.DASHBOARD_MERCHANDISE_DETAIL}/${user?.user_name}/${encodeURIComponent(merchSk)}/${BIO_URL_SEGMENTS.STORE}/${STORE_MONETIZE_TYPE.nft}`;
      }
    } else if (productValue?.product_type === STORE_MONETIZE_TYPE.downloadables) {
      const downloadableId = productValue.sk?.split(BIO_PRODUCT_PREFIXES.HASH)?.[1];
      URL = `${BIO_URL_SEGMENTS.DASHBOARD_MERCHANDISE_DETAILS}/${user?.user_name}&${user?.gsi4pk}/${BIO_URL_SEGMENTS.DOWNLOADABLE}/${downloadableId}/${BIO_URL_SEGMENTS.DOWNLOADABLES_UPPER}`;
    } else {
      pk = productValue.pk?.replace(BIO_PRODUCT_PREFIXES.USER, '') || '';
      sk = productValue.sk?.replace(BIO_PRODUCT_PREFIXES.USER, '') || '';
      URL = `${BIO_URL_SEGMENTS.DASHBOARD_MERCHANDISE_DETAILS}/${user?.user_name}&${user?.gsi4pk}/${encodeURIComponent(pk)}/${encodeURIComponent(sk)}/${BIO_URL_SEGMENTS.STORE}`;
    }

    if (returnUrlOnly) {
      return URL || '';
    }

    if (URL) {
      this.router.navigate([URL]);
      return true;
    }
    return false;
  }

  /**
   * Follows the white label owner automatically if the current user is on a white label website
   * and is not the owner themselves
   */
  automaticFollowUser(checkforwhitlelabel: boolean = true, following_email?: string): void {
    let ownerGsi4pk: string | undefined;
    let ownerEmail: string | undefined;
    
    if (checkforwhitlelabel) {
      if (!this.isWhiteLabelWeb) {
        return;
      }
      const whiteLabelConfig = this.getWhiteLabelConfiguration();
      ownerGsi4pk = whiteLabelConfig?.user?.gsi4pk;
      ownerEmail = whiteLabelConfig?.user?.email;
      if (!ownerGsi4pk) {
        return;
      }
      // Get logged-in user's email
      const loggedInUser = this.getLoggedInUser();
      const currentUserEmail = loggedInUser?.email;
      
      // Don't follow if the logged-in user is the white label owner
      if (currentUserEmail && ownerEmail && currentUserEmail?.toLowerCase() === ownerEmail?.toLowerCase()) {
        return;
      }
      
      // Don't follow if logged-in user's gsi4pk matches owner's gsi4pk
      if (loggedInUser?.gsi4pk && loggedInUser.gsi4pk === ownerGsi4pk) {
        return;
      }
    }
    
    // Use following_email from parameter if provided, otherwise use ownerGsi4pk from white label config
    const emailToFollow = following_email || ownerGsi4pk;
    if (!emailToFollow) {
      return;
    }
    
    // Using require to break circular dependency at module load time
    const apiCallService = this.injector.get(ApiCallService);
    
    const payload = {
      following_email: emailToFollow,
      is_restricted: true
    };    
    apiCallService.post(API_URLS.followUser, payload, false).subscribe({
      next: () => {},
      error: () => {}
    });
  }

  /**
   * Same-origin internal path only (avoids open redirects).
   */
  private sanitizePortfolioReturnUrl(url: string | undefined): string | undefined {
    if (!url || typeof url !== 'string') {
      return undefined;
    }
    const u = url.trim();
    if (!u.startsWith('/') || u.startsWith('//')) {
      return undefined;
    }
    return u;
  }

  getPortfolioNavigationRoute = (
    userName: string,
    sk: string,
    portfolioType: string,
    portfolioTypeId?: string,
    openPlayer?: boolean,
    newWindow?: boolean,
    returnUrl?: string
  ) => {
    const type = PORTFOLIO_TYPE_ROUTE_PATH_MAP[portfolioType.toLowerCase()];
    const routePath = PORTFOLIO_PROFILE_ROUTES[portfolioType];
    const encodedSk = this.encodePortfolioSk(sk);
    const path = ['/dashboard/portfolio', userName, routePath, encodedSk];
    const queryParams = { portfolioType: type, portfolioTypeId: portfolioTypeId || '', openPlayer };
    const safeReturn = this.sanitizePortfolioReturnUrl(returnUrl);
    const state = safeReturn ? { portfolioReturnUrl: safeReturn } : {};
    if (newWindow) {
      const urlTree = this.router.createUrlTree(path, { queryParams });
      const fullUrl = `${environment.websiteURL}${this.router.serializeUrl(urlTree)}`;
      this.openUrl(fullUrl);
    } else {
      this.router.navigate(path, { queryParams, state });
    }
    return;
  };

  updateSignInVisibility(): boolean {
    const url = this.router.url;
    
    const hideSignInForRoutes = [
      '/content/setup-profile',
      '/sports-teams',
      '/professionals',
      '/athlete',
      '/health-wellness',
      '/music',
      '/music-artists',
      '/health-fitness-food',
      '/athletes',
      ...this.marketingPagesRoutes,
      ...this.marketingProPagesRoutes
    ];
    
    return !(
      hideSignInForRoutes.some(route => url.startsWith(route))
    );
  }


  setExperienceMerchandiseSubscribedPlanList(element: any) {
    const experiences = element?.included_experiences;
    const merchandise = element?.included_merchandise;

    if (!experiences?.length && !merchandise?.length) {
      element.expMer = [];
      return element.expMer;
    }

    if (experiences?.length) {
      experiences.forEach((item: any) => {
        const frequency = item.usage_per_period || item.usage_limit;
        item.subtitle = `${frequency} Per Month`;
        item.termsAndConditions = termsAndConditionsSubExperience;
        item.code = item?.discount_code ?? null;
        item.optionTitle = CREATE_PLAN_CONSTANTS.EXPERIENCE_OPTIONS;
      });
    }

    let merchandiseData = merchandise;
    if (merchandise?.length) {
      merchandiseData = [cloneeDeep(merchandise[0])];
      set(merchandiseData, '0.title', CREATE_PLAN_CONSTANTS.FREE_MERCHANDISE);
      set(merchandiseData, '0.subtitle', CREATE_PLAN_CONSTANTS.ONE_PER_TERM);
      set(merchandiseData, '0.termsAndConditions', termsAndConditionsSubMerchandise);
      set(merchandiseData, '0.code', merchandise[0]?.discount_code ?? null);
      set(merchandiseData, '0.optionTitle', CREATE_PLAN_CONSTANTS.MERCHANDISE_OPTIONS);

      const ids = merchandise.map((item: any) => { return { title: item.title, sk: item.sk } });
      set(merchandiseData, '0.ids', ids);
    }

    const expMer = [
      ...(merchandiseData || []),
      ...(experiences || [])
    ];

    element.expMer = expMer;

    return expMer
  }
}
